<template>
  <section class="flipContent">
    <h2 class="nowhereFont">Purpose</h2>
    <meeting-info
      v-bind="$attrs"
      id="flipTitleSection"
      key="flipTitle"
      :field="meetingStore.name"
      :edited-by="meetingStore.editing.name"
      :extra="props.extra"
      name="name"
      edit-name="title"
      default-text="Add meeting title..."
      type="heading"
      truncate="false"
    />

    <h3 key="flipPurposeHeading" class="infoHeading">Purpose</h3>
    <meeting-info
      v-bind="$attrs"
      id="flipPurposeSection"
      key="flipPurpose"
      :field="meetingStore.purpose"
      :edited-by="meetingStore.editing.purpose"
      :extra="props.extra"
      expanded="true"
      name="purpose"
      default-text="Add meeting purpose"
      type="paragraph"
      truncate="true"
    />

    <h3 key="flipObjectivesHeading" class="infoHeading">Objectives</h3>
    <meeting-info
      v-bind="$attrs"
      id="flipObjectivesSection"
      key="flipObjectives"
      :field="meetingStore.objectives"
      :edited-by="meetingStore.editing.objectives"
      :extra="props.extra"
      expanded="true"
      name="objectives"
      default-text="Add meeting objectives..."
      type="list"
      truncate="false"
    />

    <h3 v-if="meetingStore.outputs.length > 0" key="flipOutputsHeading" class="infoHeading">Outputs</h3>
    <meeting-info
      v-bind="$attrs"
      v-if="meetingStore.outputs.length > 0"
      id="flipOutputsSection"
      key="flipOutputs"
      :field="meetingStore.outputs"
      :edited-by="meetingStore.editing.outputs"
      :extra="props.extra"
      expanded="true"
      name="outputs"
      default-text="Add meeting outputs..."
      type="list"
      truncate="false"
    />

    <h3 v-if="meetingStore.outcomes.length > 0" key="flipOutcomesHeading" class="infoHeading">Outcomes</h3>
    <meeting-info
      v-bind="$attrs"
      v-if="meetingStore.outcomes.length > 0"
      id="flipOutcomesSection"
      key="flipOutcomes"
      :field="meetingStore.outcomes"
      :edited-by="meetingStore.editing.outcomes"
      :extra="props.extra"
      expanded="true"
      name="outcomes"
      default-text="Add meeting outcomes..."
      type="list"
      truncate="false"
    />
  </section>
</template>

<script setup>
import { useMeetingStore } from '@/store/pinia/meeting';
import MeetingInfo from '@/components/MeetingInfo';
const props = defineProps(['extra']);

const meetingStore = useMeetingStore();
</script>
<style lang="scss" scoped>
.flipContent {
  margin: 0 rem($sidebar-left-pad);

  & > h2 {
    margin: rem(36px) 0 rem(35px) 0;
    text-align: center;
    @include type-size('large');
    .extraContent & {
      text-align: left;
    }
  }
  :deep(.meetingTitle) {
    @include type-size('medium');
    font-weight: 800;
  }

  :deep(.infoHeading) {
    // padding: 0 rem($sidebar-left-pad);
    flex: 0 0 auto;
    font-weight: bold;
    display: inline-block;
    margin-top: 1em;
  }
}
</style>
